import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import SEND_CONTACT_MUTATION from '../../../graphql/SendTheaterContact';

class ContactTheaterForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      message: '',
      error: undefined,
      success: undefined,
    };
  }

  send = (e) => {
    e.preventDefault();
    const { name, email, message } = this.state;
    const { mutate, id } = this.props;

    if (!name || !email || !message) {
      this.setState({ error: 'Debes especificar tu nombre, correo y mensaje.', success: '' });
      return;
    }

    mutate({
      variables: {
        id,
        name,
        email,
        message,
      },
    })
      .then(() => {
        this.setState({
          message: '',
          error: '',
          success: 'Mensaje enviado correctamente',
        });
      })
      .catch(() => {
        this.setState({
          success: '',
          error: 'Ocurrió un problema al enviar el mensaje',
        });
      });
  };

  render() {
    return (
      <div className="contact-form">
        <form onSubmit={this.send}>
          {this.state.error && (
            <div className="alert alert-danger" role="alert">
              {this.state.error}
            </div>
          )}
          {this.state.success && (
            <div className="alert alert-success" role="alert">
              {this.state.success}
            </div>
          )}

          <div className="form-group">
            <label>Nombre</label>
            <input name="name" className="input-text" placeholder="Nombre" value={this.state.name} onChange={e => this.setState({ name: e.target.value })} />
          </div>
          <div className="form-group">
            <label>Correo electrónico</label>
            <input name="email" className="input-text" placeholder="Correo electrónico" value={this.state.email} onChange={e => this.setState({ email: e.target.value })} />
          </div>
          <div className="form-group">
            <label>Mensaje</label>
            <textarea className="input-text" name="message" placeholder="Escribe un mensaje" value={this.state.message} onChange={e => this.setState({ message: e.target.value })} />
          </div>
          <div className="form-group send-btn">
            <button type="submit" className="button-md button-theme">Enviar mensaje</button>
          </div>
        </form>
      </div>
    );
  }
}

ContactTheaterForm.propTypes = {
  id: PropTypes.string.isRequired,
};


const withMutation = graphql(SEND_CONTACT_MUTATION);

export default withMutation(ContactTheaterForm);



// WEBPACK FOOTER //
// ./src/containers/Others/ContactTheaterForm/index.js